import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Layout from "./Layout/Layout";
import { Suspense } from "react";
import Enroll from "./pages/Enroll";
// import Session from "./pages/Session";
// import Profile from "./pages/StudentsProfile"; // This line will be removed
import Auth from "./pages/Auth";
// import TeacherClassRoom from "./pages/TeacherClassRoom";
import AppLayout from "./pages/AdminDashboard";
import NotFound from "./pages/NotFound";
import StudentProfile from "./pages/StudentProfile"; // Your local change
import React from "react"; // From the remote changes
import TeachersProfile from "./pages/TeachersProfile";
import { ToastContainer } from "react-toastify"; // Import ToastContainer
import Middleware from "./components/Middleware/Middleware";
import CourseDetailPage from "./pages/CourseDetailPage";
import SessionMiddleware from "./components/Session/SessionMiddleware";
import HowItWorks from "./pages/HowItWorks";
import Contact from "./pages/Contact";
import About from "./pages/About";
import Unauthorized from "./pages/Unauthorized";
import ComingSoon from "./pages/ComingSoon";
import Help from "./pages/Help";
import AllTerms from "./pages/TermsandConditions/AllTerms";
import Room from "./pages/Room";
import SimplethreeDot from "./components/common/Loadinganimations/SimplethreeDot";
import ChatButton from "./components/common/Button/ChatButton";

function App() {
	return (
		<BrowserRouter>
			<Suspense fallback={<SimplethreeDot />}>
				<ToastContainer className="z-[10000]" />
				<Routes>
					{/* Routes using the Layout component */}

					<Route
						path="/"
						element={
							<>
								<ChatButton />
								<Home />
							</>
						}
					/>
					<Route path="/unauthorized" element={<Unauthorized />} />
					<Route path="/comingsoon" element={<ComingSoon />} />
					<Route element={<Layout />}>
						<Route path="/enroll">
							<Route
								index
								element={
									<Middleware requiredRoles={["student"]}>
										<Enroll />
									</Middleware>
								}
							/>
							<Route
								path=":courseId"
								element={
									<Middleware requiredRoles={["student"]}>
										<CourseDetailPage />
									</Middleware>
								}
							/>
							{/* From remote changes */}
						</Route>
						<Route
							path="/classroom/:classroomId"
							element={
								<SessionMiddleware>
									<Room />
								</SessionMiddleware>
							}
						/>
						<Route
							path="/teachersProfile"
							element={
								<Middleware requiredRoles={["teacher"]}>
									<TeachersProfile />
								</Middleware>
							}
						/>
						<Route path="/HowItWorks" element={<HowItWorks />} />
						<Route path="/contact" element={<Contact />} />
						<Route
							path="/allterms"
							element={
								<Middleware requiredRoles={["student"]}>
									<AllTerms />
								</Middleware>
							}
						/>
						<Route path="/about" element={<About />} />
						<Route path="/help" element={<Help />} />
						<Route
							path="/studentProfile"
							element={
								<Middleware requiredRoles={["student"]}>
									<StudentProfile />
								</Middleware>
							}
						/>{" "}
						{/* Your local change */}
					</Route>

					{/* Routes that do not use the Layout component */}
					<Route path="/auth" element={<Auth />} />

					<Route
						path="/admin/*"
						element={
							<Middleware requiredRoles={["admin"]}>
								<AppLayout />
							</Middleware>
						}
					/>

					{/* Catch-all route for undefined paths */}
					<Route path="*" element={<NotFound />} />
				</Routes>
			</Suspense>
		</BrowserRouter>
	);
}

export default App;
